namespace RedBullMOBILE360.Web.Modules.Common {
    export enum ActionType {
        Closed_FalseComplaint = 1,
        Resumed = 2,
        Barred = 3,
        Suspended = 4,
        Deactivated = 5,
        Closed_SimBox_NotRBM = 6,
        Close = 7,
        ActionPeriodUpdated = 8,
        ResumeFailed = 9,
        Unbarred = 10
    }
    Serenity.Decorators.registerEnumType(ActionType, 'RedBullMOBILE360.Web.Modules.Common.ActionType');
}
